import { render, staticRenderFns } from "./Full_Pic.vue?vue&type=template&id=aebd712c&scoped=true"
import script from "./Full_Pic.vue?vue&type=script&lang=js"
export * from "./Full_Pic.vue?vue&type=script&lang=js"
import style0 from "./Full_Pic.vue?vue&type=style&index=0&id=aebd712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebd712c",
  null
  
)

export default component.exports